import TabsPage from '../TabsPage';

import ButtonIcon from 'components/ButtonIcon';
import Button from "components/Button";
import Table from 'components/Table';

import './index.less';
import './themes/default.less';

export default class Analysis extends TabsPage {

    constructor(props) {
        super(props);

        this.tableMap = {
            createdTime: {
                label: "Дата загрузки",
                callback: this.renderDateCell.bind(this),
            },
            fileName: {
                label: "Имя файла",
            },
            comment: {
                label: "Описание",
            },
            actions2: {
                label: "main.actions",
                callback: this.renderDownloadCell.bind(this),
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
            actions: {
                type: "actions",
                items: [
                    { name: "main.edit", onClick: this.onChangeNotes.bind(this) },
                    { name: "client.delete", onClick: this.deleteDocument.bind(this) },
                ],
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
        };

        this.state = {
            ...this.state,
            items: [],
        };

    }

    componentDidMount() {
        this.refresh();
    }

    async deleteDocument({ uuid4 }) {
        this._helper.showLoading();
        await this._request.files.deletep(uuid4);
        this._helper.hideLoading();
        this.refresh();
    }

    async downloadDocument(imageUrl, imageName) {
        this._helper.showLoading();
        await this._request.files.downloadDocument(imageUrl, imageName);
        this._helper.hideLoading();
    }

    async updateComment(comment, id) {
        this._helper.showLoading();
        await this._request.fileStorage.update(id, comment);
        this._helper.hideLoading();
        this.refresh();
    }

    onChangeNotes(info) {
        this._helper.openDialog("changeNote", info, this.updateComment.bind(this));
    }

    renderDateCell(value) {
        return this._helper.date.toStr(this._helper.date.toLocal(value), "DD.MM.YYYY HH:mm");
    }

    renderDownloadCell(value, map, { source, fileName }) {
        return <ButtonIcon name="download" onClick={this.downloadDocument.bind(this, source, fileName)} />;
    }

    refresh() {
        this.getData();
    }

    async getData() {
        this._helper.showLoading();

        const { id } = this.props.info;
        const respFile = await this._request.fileStorage.getAnalisisClient(id);
        const items = (respFile?.data || []);
        this.setState({ items });

        this._helper.hideLoading();
    }

    renderContent() {
        const { items } = this.state;
        const { openDialog, clinicId } = this.props;
        const info = {
            infoFile: {
                domainId: clinicId,
                domain: "medical_tests",
                type: "DOCUMENT",
                clientId: this.props.info.id,
            },
            title: "Загрузка файла"
        };
        const addFile = openDialog.bind(this, "fileUpload", info, this.refresh.bind(this));

        return (<div className="analysis flex1 flex col gap16">
            <div className="flex between">
                <div className="text blockTitle">
                    {this.tr("client.analysis")}
                </div>
                <div>
                    <Button
                        type={"secondary"}
                        size={"small"}
                        label={"price.fileLoading"}
                        onClick={addFile}
                    />
                </div>
            </div>
            <Table
                map={this.tableMap}
                items={items}
            />
        </div>);
    }
}
